$(() => {
  $('.items p').each(function () {
    var str = $(this).text();
    str = str.replace(/\s/g, '');
    $(this).text(str);
  });
});
